// Local translations
export const T = {
  en_GB: {
    selectDocument: "Select Document",
    multipleDocumentsFound: "Multiple documents found. Please select which one to use.",
    noLanguageMatch:
      "No {language} document found in Morningstar. Select a document in another language to attach to the {language} section.",
    unmappedLanguage:
      "Morningstar has no {language} documents. Select a document in another language to attach to the {language} section.",
    language: "Language",
    market: "Market",
    date: "Date",
    action: "Action",
    select: "Select",
  },
  nb_NO: {
    selectDocument: "Velg dokument",
    multipleDocumentsFound: "Flere dokumenter funnet. Vennligst velg hvilket som skal brukes.",
    noLanguageMatch:
      "Ingen dokument på {language} funnet i Morningstar. Velg et dokument på et annet språk for å legge det til i seksjonen for {language}.",
    unmappedLanguage:
      "Morningstar har ingen dokumenter på {language}. Velg et dokument på et annet språk for å legge det til i seksjonen for {language}.",
    language: "Språk",
    market: "Marked",
    date: "Dato",
    action: "Handling",
    select: "Velg",
  },
} as const;
